// The longest card, in minutes, that has room for the title line only.
export const SHORT_CARD_MAX_MINUTES = 30;

/**
 * The title line of a session or a hold card.
 *
 * A card of 30 minutes or less has room for the title line only, so the time
 * line and its bay are cut off. Such a card puts the label (the bay, or the
 * coach in the Resources view) on the title line. With the feature off the
 * label is empty, and the title stays as it was.
 */
export function titleWithLabel(
  title: string,
  label: string | undefined,
  durationInMinutes: number | undefined,
): string {
  if (!label || (durationInMinutes ?? 0) > SHORT_CARD_MAX_MINUTES) {
    return title;
  }

  return `${title} \u00B7 ${label}`;
}
